import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TuiPush, TuiTabs } from '@taiga-ui/kit';
import { TuiLet } from '@taiga-ui/cdk';
import {
  TuiFormatPhonePipe,
  TuiTextfieldControllerModule,
  TuiSheetModule,
  TuiInputModule,
  TuiInputNumberModule,
  TuiInputPasswordModule,
} from '@taiga-ui/legacy';
import { TuiNotification, TuiLoader, TuiScrollbar, TuiScrollable, TuiButton, TuiHint } from '@taiga-ui/core';
import { SharedModule } from '@src/app/shared';
import { ComponentsModule } from '@src/app/components';
import { LogoModule } from '@src/app/modules/logo';
import { CoreModule } from '@src/core';
import { DialogsModule } from '@src/app/shared/dialogs';
import { CaptchaModule } from '@src/app/modules/captcha';
import { InputCodeModule } from '@src/app/modules/input-code';
import { PhoneModule } from '@src/app/modules/phone';
import { AppConfigModule } from '@src/app/modules/app-config';

import { LoginComponent } from './login.component';
import { EnterByCodeComponent } from './components/enter-by-code/enter-by-code.component';
import { DownloadLinksComponent } from './components/download-links/download-links.component';
import { PolicyComponent } from './components/policy/policy.component';

@NgModule({
  declarations: [LoginComponent, EnterByCodeComponent, DownloadLinksComponent, PolicyComponent],
  imports: [
    CommonModule,
    FormsModule,
    LogoModule,
    PhoneModule,
    RouterModule,
    TuiButton,
    TuiInputModule,
    TuiInputNumberModule,
    TuiInputPasswordModule,
    TuiLet,
    TuiLoader,
    TuiScrollbar,
    TuiScrollable,
    TuiSheetModule,
    TuiTextfieldControllerModule,
    ...TuiPush,
    SharedModule,
    ComponentsModule,
    CoreModule,
    TuiFormatPhonePipe,
    DialogsModule,
    CaptchaModule,
    TuiNotification,
    InputCodeModule,
    ...TuiTabs,
    AppConfigModule,
    ...TuiHint,
  ],
  exports: [LoginComponent, PolicyComponent],
})
export class LoginModule {}
